function ReferenceLink() {
  return (
    <>
      <p>.برای مشاهده اطلاعیه سازمان سنجش در مورد زیر‌گروه‌ها و ضرایب روی لینک زیر کلیک کنید</p>
      <a
        referrerPolicy='origin'
        target='_blank'
        rel='noopener noreferrer'
        href='https://medmoshaver.com/shared_files/exam/documents/اطلاعیه_زیرگروه‌ها.pdf'
        className='font-medium text-blue-800'
      >
        اطلاعیه سازمان سنجش در مورد زیر‌گروه‌ها و ضرایب
      </a>
    </>
  );
}

export default ReferenceLink;
